module.exports = __webpack_public_path__ + "media/images/plus-9db8a509ad4dfa8750ba4985b49064d7.svg";